const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid white',
    width: '25px',
    height: '25px',
    borderRadius: '50%',
    marginLeft: '16px',
  },
  label: {
    color: 'white',
    fontSize: '14px',
    lineHeight: '1',
    fontWeight: 'bold',
  },
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/ChatUnreadIndicator/styles.js